export const checkInError = [
  {
    path: '/falha-checkin',
    name: 'service-desk-checkin',
    component: () => import('@/views/conclusion/GenericServiceDesk.vue'),
    meta: {
      disabledPageReloadGuard: true,
      reason: 'JWT error',
      publicRoute: true,
      header: {
        hidePreviousBtn: true,
      },
    },
  },
  {
    path: '/falha-checkin',
    name: 'service-desk-checkin-mobile-service',
    component: () => import('@/views/conclusion/GenericServiceDesk.vue'),
    meta: {
      disabledPageReloadGuard: true,
      reason: 'JWT error',
      publicRoute: true,
      header: {
        title: 'Falha no check-in',
        hidePreviousBtn: true,
      },
      body: {
        title: 'Seu atendimento será finalizado pelo nosso time no dia do seu agendamento.',
        btnLabel: 'Ok, entendi',
        config: {
          showName: false,
          showSubtitle: false,
          showList: false,
        },
      },
    },
  },
];
